import { BaseApi } from './base.api.js';

export class AssetCategoryApi extends BaseApi {
    constructor(client) {
        super(client, '/asset-category');
    }
}
